import { CalendarRange, Eye, Loader2, MailCheck, Send } from "lucide-react";
import { Button } from "@/components/ui/button";

/** One button: spinner while it is the busy job, its own icon otherwise. */
const ActionButton = ({ icon: Icon, label, busy, onClick, disabled, testId, variant }) => (
  <Button
    type="button"
    variant={variant}
    onClick={onClick}
    disabled={disabled}
    data-testid={testId}
    className={variant === "outline" ? "h-10 bg-white" : "h-10"}
  >
    {busy ? (
      <Loader2 className="mr-2 h-4 w-4 animate-spin" aria-hidden="true" />
    ) : (
      <Icon className="mr-2 h-4 w-4" aria-hidden="true" />
    )}
    {label}
  </Button>
);

/** Preview and send-now buttons for the chase list and the weekly recap. */
export const EmailActions = ({ configured, busy, actions }) => (
  <>
    <div className="mt-4 flex flex-wrap gap-2">
      <ActionButton
        icon={Eye}
        label="Preview the chase list"
        variant="outline"
        busy={busy === "preview"}
        disabled={busy === "preview"}
        onClick={actions.openPreview}
        testId="email-panel-preview-button"
      />
      <ActionButton
        icon={Send}
        label="Send it to me now"
        busy={busy === "digest"}
        disabled={!configured || busy === "digest"}
        onClick={actions.sendDigest}
        testId="email-panel-send-digest-button"
      />
      <ActionButton
        icon={MailCheck}
        label="Send a test email"
        variant="outline"
        busy={busy === "test"}
        disabled={!configured || busy === "test"}
        onClick={actions.sendTest}
        testId="email-panel-test-button"
      />
      <ActionButton
        icon={CalendarRange}
        label="Preview the week in review"
        variant="outline"
        busy={busy === "weekly-preview"}
        disabled={busy === "weekly-preview"}
        onClick={actions.openWeekly}
        testId="email-panel-weekly-preview-button"
      />
      <ActionButton
        icon={Send}
        label="Send the recap now"
        busy={busy === "weekly-send"}
        disabled={!configured || busy === "weekly-send"}
        onClick={actions.sendWeekly}
        testId="email-panel-send-weekly-button"
      />
    </div>

    {!configured ? (
      <p className="mt-2 text-[12px] text-muted-foreground">
        Sending is disabled until a Resend key is set — preview still works.
      </p>
    ) : null}
  </>
);
